import React, {useState, useMemo} from 'react';
import PropTypes from 'prop-types';
import base_url from '../../baseUrls';
import * as allConstants from '../../constants/allConstants';
import MyPaginatedGrid from '../../pieces/grids/paginatedGridWrapper';
import ColumnDefinition from '../../pieces/grids/columnGenerator';
import StatusRenderer from '../../pieces/grids/statusRenderer';
import {NewPermissionGate} from '../../permissions/permissionGate';
import {ACCOUNTING_ELEMENTS, productsPageRules} from '../../permissions/accountingAccessControl';


const AllProductsGrid = (props) => {
  const viewController = props.viewController;
  const [components] = useState({
    'statusRenderer': StatusRenderer,
  });

  const fetchParams = useMemo(() => ({url: `${base_url.api}products/`, respKey: 'products'}), []);

  const productColumns = {
    id: new ColumnDefinition({field: allConstants.PRODUCT_FIELDS.ID, hide: true}),
    name: new ColumnDefinition({
      field: allConstants.PRODUCT_FIELDS.NAME,
      lockPinned: true,
      pinned: 'left',
      checkboxSelection: true,
      width: 350,
      wrapText: true,
    }),
    category: new ColumnDefinition({
      field: allConstants.PRODUCT_FIELDS.CATEGORY,
      width: 200,
      filter: 'agSetColumnFilter',
      filterValues: Object.values(allConstants.PRODUCT_CATEGORIES_OPTIONS).map((s) => s.value),
    }),
    price: new ColumnDefinition({
      field: allConstants.PRODUCT_FIELDS.PRICE,
      filter: 'agNumberColumnFilter',
      width: 150,
    }),
    code: new ColumnDefinition({field: allConstants.PRODUCT_FIELDS.CODE, width: 150}),
    description: new ColumnDefinition({
      field: allConstants.PRODUCT_FIELDS.DESCRIPTION,
      wrapText: true,
    }),
  };

  const getColumns = () => [
    productColumns.id,
    productColumns.name,
    productColumns.category,
    productColumns.price,
    productColumns.code,
    productColumns.description,
  ];

  const columnDefs = useMemo(() => getColumns(), []);

  const editProductHandler = (productData)=> {
    props.editProductHandler(productData);
  };

  const deleteProductHandler = (productData)=> {
    props.deleteProductHandler(productData);
  };

  const getContextMenuItems = (params)=> {
    if(!params.node) return [];

    const standardActions = [
      {
        name:  'Export Selected (.xlsx)',
        action: () => params.api.exportDataAsExcel(
          {onlySelected: true}
        )
      },
      'copy',
    ];

    const actions = {
      edit: {
        name: 'Edit',
        disabled: viewController.selectedMultipleRows(),
        action: () => {
          editProductHandler(params?.node?.data);
        },
      },
      delete: {
        name: 'Delete',
        cssClasses: ['redFont', 'bold'],
        disabled: viewController.selectedMultipleRows(),
        action: () => {
          deleteProductHandler(params?.node?.data);
        },
      },
    };

    let allowedActions = [];
    if(NewPermissionGate({
      user: viewController.user,
      elementPermissions: productsPageRules[ACCOUNTING_ELEMENTS.editProduct],
    })) {
      allowedActions.push(actions.edit);
    }

    allowedActions = [...allowedActions, ...standardActions];

    return allowedActions;
  };

  return (
    <MyPaginatedGrid columnDefs={columnDefs}
      components={components}
      contextMenu={getContextMenuItems}
      ls_name={'products_grid'}
      registerGrid={viewController.setGridToParent}
      registerTempGrid={viewController.setTempGridToParent}
      fetchParams={fetchParams}
      companyId={viewController.companyId}
      onFetchFail={viewController.onFetchFail}
      pagination={props.pagination}
      refreshTimestamp={viewController.refreshTimestamp}
    />
  );
};

AllProductsGrid.propTypes = {
  editProductHandler: PropTypes.func.isRequired,
  deleteProductHandler: PropTypes.func.isRequired,
  pagination: PropTypes.instanceOf(Object).isRequired,
  viewController: PropTypes.instanceOf(Object).isRequired,

};
export default AllProductsGrid;
